import { Component, ElementRef, HostListener, inject } from '@angular/core';
import { finalize } from 'rxjs';
import { ImagesService } from '../../services/general/images.service';
import { UserModelInterfaces } from '../../interfaces/responses/user-model.interfaces';
import { Router } from '@angular/router';
import { ChangePasswordComponent } from '../overlays/change-password/change-password.component';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from '../shared/confirmation-dialog/confirmation-dialog.component';
import { ThemeService } from '../../services/general/theme.service';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-menu-bar',
  imports: [CommonModule, ChangePasswordComponent, ConfirmationDialogComponent],
  templateUrl: './menu-bar.component.html',
  styleUrl: './menu-bar.component.scss'
})
export class MenuBarComponent {

  _images = inject(ImagesService);
  theme = inject(ThemeService);
  isProfileClicked: boolean = false;
  isChangePasswordOpen: boolean = false;
  showLogoutDialog: boolean = false;
  userData: UserModelInterfaces = {
    accessToken: '',
    exp: '',
    firstLogin: false,
    user: {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      roles: []
    }
  };
  _eref = inject(ElementRef);
  _router = inject(Router);
  _authService = inject(AuthService);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target;
    const isClickInside = this._eref.nativeElement.contains(target);

    if (!isClickInside) {
      this.isProfileClicked = false;
    }
  }

  ngOnInit(): void {
    //  retrieve user data from local storage
    let userData: string | null = null;

    if (typeof window !== 'undefined') {
      userData = localStorage.getItem('userInfo');
    } else {
      console.warn('localStorage is not available (SSR)');
    }
    if (userData) {
      this.userData = JSON.parse(userData);
    }
  }

  getCurrentDate(): string {
    const date = new Date();
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const day = days[date.getDay()];
    const month = months[date.getMonth()];
    const dateNumber = date.getDate();

    // Add suffix for the date
    const suffix = (dateNumber % 10 === 1 && dateNumber !== 11) ? 'st' :
      (dateNumber % 10 === 2 && dateNumber !== 12) ? 'nd' :
        (dateNumber % 10 === 3 && dateNumber !== 13) ? 'rd' : 'th';

    return `${day}, ${dateNumber}${suffix} ${month} ${date.getFullYear()}`;
  }

  getCurrentTime(): string {
    const date = new Date();
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // If hours is 0, set it to 12

    // Add leading zero to minutes if needed
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${hours}:${formattedMinutes}${ampm}`;
  }

  onProfileClick() {
    this.isProfileClicked = !this.isProfileClicked
  }


  onLogOutClicked() {
    this.showLogoutDialog = true;
    this.isProfileClicked = false;
  }

  confirmLogout() {
    this._authService.logout().pipe(
      finalize(() => {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('tokenn');
        this.showLogoutDialog = false;
        this._router.navigate(['/auth/login']);
      })
    ).subscribe({
      error: () => {} // backend logout failure doesn't block local logout
    });
  }

  cancelLogout() {
    this.showLogoutDialog = false;
  }

  onChangePasswordClick() {
    this.isChangePasswordOpen = true;
    this.isProfileClicked = false;
    // Add class to body to hide filters when modal is open
    if (typeof document !== 'undefined') {
      document.body.classList.add('modal-open');
      // Close any open filter dropdowns by dispatching a click event
      setTimeout(() => {
        document.body.click();
      }, 0);
    }
  }

  onCloseChangePassword() {
    this.isChangePasswordOpen = false;
    // Remove class from body when modal closes
    if (typeof document !== 'undefined') {
      document.body.classList.remove('modal-open');
    }
  }
}
